import React, { memo, useState, useEffect } from "react";
import { OrdersMain } from "./styles/OrdersStyles";
// import Orders from "./data/orders.json";
import TableMain from "../shared/TableMain";
import NotFoundIcon from "../../shared/NotFoundIcon";

const CustomerOrders = ({
  AllData = [],
  CurrentPage = 1,
  setCurrentPage = () => {},
}) => {
  const [OrdersData, SetOrdersData] = useState([]);
  useEffect(() => {
    if (
      AllData &&
      AllData?.message === "Success" &&
      AllData?.data?.orders?.data?.length > 0
    ) {
      const modifiedData = AllData?.data?.orders?.data?.map((values) => {
        const Sender = values?.stops[0]?.contact_name;
        const order_id = values?.order_id;
        const created_at = values?.created_at;
        const Receiver = values?.stops[1]?.contact_name;

        const Order = values?.stops[0]?.order_detail?.name;
        const Driver = values?.driver_name;
        const Price = values?.price;
        const status = values?.status;
        // const Driver = values?.driver_name;

        // Remove the "stops" array from the object using destructuring
        // const { stops, ...modifiedValues } = values;

        return {
          // ...modifiedValues,
          order_id,
          created_at,
          Sender,
          Receiver,
          Order,
          Driver,
          Price,
          status,
        };
      });

      // Update the OrdersData state with the modified array
      SetOrdersData(modifiedData || []);
    }
  }, [AllData, CurrentPage]);

  const TableHeadData = [
    { title: "Order ID", val: "order_id" },
    { title: "Date & Time", val: "DateTime" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Order", val: "Order" },
    { title: "Driver", val: "Driver" },
    { title: "Price", val: "Price" },
    { title: "Status", val: "status" },
  ];

  return AllData && AllData?.message === "Success" && OrdersData.length > 0 ? (
    <>
      <OrdersMain>
        <TableMain
          TableHeadData={TableHeadData}
          BodyData={OrdersData}
          Hasaction={false}
          TableType="customers"
          Last_page={AllData?.data?.orders?.orders_last_page}
          total_pages={AllData?.data?.orders?.orders_total_pages}
          CurrentPage={CurrentPage}
          setCurrentPage={setCurrentPage}
        />
      </OrdersMain>
    </>
  ) : (
    <NotFoundIcon MT="20" IconWidth="10" />
  );
};

export default memo(CustomerOrders);
